export default {
    MP: 'Menor Preço',
    MD: 'Maior Desconto',
    MO: 'Maior Oferta',
    MRO: 'Maior Retorno Econômico',
    MTC: 'Melhor Técnica',
    TP: 'Técnica e Preço',
    ML: 'Maior Lance',
    CA: 'Conteúdo Artístico',
    MT: 'Menor Taxa Administrativa',
    NA: 'Não se Aplica'
}
